import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "../styles/Home.css";

const HomeMobile = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [ended, setEnded] = useState(false);
  const [progress, setProgress] = useState(0);

  const toggleMenu = () => setMenuOpen((v) => !v);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const el = audioRef.current;
    if (!el) return;

    const onTime = () => {
      if (!el.duration) return;
      setProgress((el.currentTime / el.duration) * 100);
    };

    const onEnded = () => {
      setIsPlaying(false);
      setEnded(true);
    };

    el.addEventListener("timeupdate", onTime);
    el.addEventListener("ended", onEnded);
    return () => {
      el.removeEventListener("timeupdate", onTime);
      el.removeEventListener("ended", onEnded);
    };
  }, []);

  return (
    <div className="home-page">
      <div className="phone-frame">
        <div className="card">
          <header className="card-header">
            <img src="/logo.png" alt="Logo Find ID" className="logo-img" />
            <button
              className="menu-badge"
              onClick={toggleMenu}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              aria-label="Ouvrir le menu"
            >
              <svg
                className="menu-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
          </header>

          {menuOpen && (
            <>
              <button
                className="menu-overlay"
                onClick={closeMenu}
                aria-label="Fermer le menu"
              />
              <aside className="menu-panel" role="menu">
                <div className="menu-header">
                  <span>Menu</span>
                  <button
                    className="menu-close"
                    onClick={closeMenu}
                    aria-label="Fermer"
                  >
                    ×
                  </button>
                </div>
                <nav className="menu-list">
                  <Link to="/" onClick={closeMenu}>
                    Accueil
                  </Link>
                  <Link to="/piece-ramace" onClick={closeMenu}>
                    Déclarer une pièce Ramassée
                  </Link>
                  <Link to="/piece-perdu" onClick={closeMenu}>
                    Déclarer une pièce perdue
                  </Link>
                  <Link to="/mes-declarations" onClick={closeMenu}>
                    Mes déclarations
                  </Link>
                  {/* <Link to="/admin-login" onClick={closeMenu}>
                    Admin
                  </Link> */}
                </nav>
              </aside>
            </>
          )}

          <audio ref={audioRef} src="/audio/bell.mp3" preload="metadata" />

          <section className="section">
            <h3 className="section-title">Annonce</h3>
            <div className="announce">
              <button
                className={`icon-box ${isPlaying ? "is-playing" : ""} ${
                  ended ? "is-ended" : ""
                }`}
                onClick={async () => {
                  const el = audioRef.current;
                  if (!el) return;
                  try {
                    if (isPlaying) {
                      el.pause();
                      setIsPlaying(false);
                    } else {
                      setEnded(false);
                      await el.play();
                      setIsPlaying(true);
                    }
                  } catch (_) {}
                }}
                aria-label={isPlaying ? "Mettre en pause" : "Lire l'audio"}
              >
                {isPlaying ? "❚❚" : "▶"}
              </button>
              <span className="announce-text">Audio</span>
              <input
                className="progress"
                type="range"
                min="0"
                max="100"
                value={progress}
                onChange={(e) => {
                  const el = audioRef.current;
                  if (!el || !el.duration) return;
                  const pct = Number(e.target.value);
                  const t = (pct / 100) * el.duration;
                  el.currentTime = t;
                  setProgress(pct);
                  if (pct < 100) setEnded(false);
                }}
                aria-label="Progression"
              />
            </div>
          </section>

          <section className="section">
            <h3 className="section-title">Déclaration</h3>
            <div className="actions">
              <Link to="/piece-ramace" className="action-btn action-found">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img
                    src="/images/emoji-content.webp"
                    alt="Icône contente"
                    style={{ width: "32px", height: "32px", marginBottom: "5px" }}
                  />
                  Déclarer une pièce Ramassée
                </div>
              </Link>

              <Link to="/piece-perdu" className="action-btn action-lost">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img
                    src="/images/emoji-triste.webp"
                    alt="Icône triste"
                    style={{ width: "32px", height: "32px", marginBottom: "5px" }}
                  />
                  Déclarer une pièce Perdue
                </div>
              </Link>
            </div>
          </section>

          <section className="section">
            <div className="image-card2">
              <img src="/images/affichehomemobil.webp" alt="Affiche" />
            </div>
          </section>

          <section className="section">
            <div
              className="image-card layout-mock"
              style={{
                backgroundImage: "url('/images/argents.webp')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              <div className="overlay"></div>
              <div className="mock-left">
                <button type="button" className="mock-btn">
                  Nous soutenir
                </button>
              </div>
            </div>
          </section>
        </div>
           
      <Footer />
      </div>
   
    </div>
  );
};

export default HomeMobile;
